"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDOMElement = getDOMElement;
function getDOMElement(selector, timeout = 5000) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }
        let timeoutRef = undefined;
        const observer = new MutationObserver(() => {
            if (document.querySelector(selector)) {
                if (timeoutRef) {
                    clearTimeout(timeoutRef);
                }
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });
        timeoutRef = setTimeout(() => {
            observer.disconnect();
            resolve(undefined);
        }, timeout);
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}
function getStringAttribute(e, name) {
    var _a;
    if (e.hasAttribute(name)) {
        return (_a = e.getAttribute(name)) !== null && _a !== void 0 ? _a : undefined;
    }
    return undefined;
}
function initFirstSearch() {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        const searchButton = yield getDOMElement("#storemapper-go");
        const input = yield getDOMElement("#storemapper-zip");
        const configValuesEl = document.querySelector(".store-locator > #config-values");
        const countryName = configValuesEl ? (_a = getStringAttribute(configValuesEl, "attr-countryName")) !== null && _a !== void 0 ? _a : "Germany" : "Germany";
        localize(searchButton, input);
        yield onFirstSearch(countryName, searchButton, input);
    });
}
function localize(searchButton, input) {
    const enDefaultSites = ["uk.mondaine.com", "eu.mondaine.com", "mondaine.com", "uk.luminox.com", "eu.luminox.com", "luminox.com"];
    const isPageGermanByDefault = enDefaultSites.indexOf(window.location.hostname) === -1;
    const url = window.location.href;
    // translate to DE
    if (url.includes("/de/") || (isPageGermanByDefault && !url.includes("/en/"))) {
        if (searchButton)
            searchButton.innerText = "Suchen";
        if (input)
            input.placeholder = "Ort eingeben";
    }
}
function onFirstSearch(countryName, searchButton, input) {
    return __awaiter(this, void 0, void 0, function* () {
        setTimeout(() => __awaiter(this, void 0, void 0, function* () {
            zoomOutAsync();
            if ((input === null || input === void 0 ? void 0 : input.value) === "") {
                searchDefaultCountryAsync(input, searchButton, countryName);
            }
            closeSelectedStorePopupAsync();
        }), 300);
    });
}
function closeSelectedStorePopupAsync() {
    getDOMElement(".gm-style-iw-t.storemapper-iw .gm-ui-hover-effect.storemapper-iw-close").then((button) => {
        button === null || button === void 0 ? void 0 : button.click();
    });
}
function searchDefaultCountryAsync(input, searchButton, countryName) {
    input.value = countryName;
    searchButton === null || searchButton === void 0 ? void 0 : searchButton.click();
}
function zoomOutAsync() {
    getDOMElement("#storemapper-right .gm-style .gmnoprint button[aria-label=\"Zoom out\"]").then(button => {
        setTimeout(() => __awaiter(this, void 0, void 0, function* () {
            for (let i = 0; i < 6; i++) {
                button === null || button === void 0 ? void 0 : button.click();
            }
        }), 100);
    });
}
function init() {
    return __awaiter(this, void 0, void 0, function* () {
        yield initFirstSearch();
    });
}
window.onload = () => {
    init();
};
